<template>
  <div class="start-div" :style="{backgroundImage:`url(${bgimage}), url(${bgImageRepeat})`}">
    <div class="start-button" :border="false">
      <div style="width: 100%; text-align: center;">
        <van-button @click="start" type="info" size="large" style="width: 50%;" round>开始锻炼</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Field, Button, Toast, Cell, CellGroup, Row, Col, Dialog} from 'vant'
export default {
  name: "ExerciseStart",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data(){
    return {
      bgimage: require('@/assets/css/start_bg.png'),
      bgImageRepeat: require('@/assets/css/start_bg_repeat.png'),
    }
  },
  methods:{
    start(){
      this.$router.push({ path: '/exercise/patterns'})
    }
  }
}
</script>

<style scoped>
  .start-title{
    text-align: center;
    font-size: 6rem;
    font-weight: bold;
    line-height: 2rem;
  }
  .start-button{
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    position: absolute;
    width: 100%;
    bottom: 10%;
  }
  .start-div{
    position: absolute;
    width: 100%;
    background-size: 100%;
    background-repeat: no-repeat, repeat-y;
    height: 100%;
    padding-bottom: 0;
  }
</style>
